import React from "react"
import { useTranslation } from "react-i18next"
import { ReactComponent as StickersIcon } from "../../icon/edit-stickers.svg"
import { ReactComponent as BackgroundsIcon } from "../../icon/edit-background-replacement.svg"
import { ReactComponent as OverlaysIcon } from "../../icon/edit-overlays.svg"
import { ReactComponent as AiEffectIcon } from "../../icon/edit-ai-effect.svg"
import Theme from "../../library/Theme"
import Typography from "@mui/material/Typography"
import { Stack } from "@mui/material"

const toolConfig: Record<
  string,
  { icon: React.FC<React.SVGProps<SVGSVGElement>>; labelKey: string }
> = {
  stickers: { icon: StickersIcon, labelKey: "edit.stickers" },
  backgrounds: { icon: BackgroundsIcon, labelKey: "edit.background" },
  overlays: { icon: OverlaysIcon, labelKey: "edit.overlay" },
  ai_effect: { icon: AiEffectIcon, labelKey: "edit.aiEffect.tab" },
}

interface EditTabProps {
  theme: Theme
  tools: string[]
  selectedIndex: number
  onSelect: (index: number) => void
}

export default function EditTabs({ theme, selectedIndex, tools, onSelect }: EditTabProps) {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      sx={{ width: 1 }}
    >
      {tools.map((tool, index) => {
        const config = toolConfig[tool]
        if (!config) return null
        const Icon = config.icon
        return (
          <Stack
            key={tool}
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
            onClick={() => onSelect(index)}
            sx={{
              flexGrow: 1,
              py: 1,
              px: 1.5,
              height: 48,
              cursor: "pointer",
              bgcolor:
                index === selectedIndex ? "rgba(255, 255, 255, 0.8)" : "rgba(255, 255, 255, 0.6)",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <Icon style={{ fill: "#333", height: "24px" }} />
            <Typography fontWeight={600}>{t(config.labelKey)}</Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}
